import React, { useState } from 'react';
import { Input, FormController, FormLabel, FormHelpMessage } from '@one-thd/sui-atomic-components';

interface GiftCardNickNameInputProps {
  gcNickName?: string;
  onReady: (nickname: string) => void;
  onError?: (errorMessage: string) => void;
}

const GiftCardNickNameInput: React.FC<GiftCardNickNameInputProps> = ({
  gcNickName,
  onReady,
  onError = () => {}
}) => {
  const [nickName, setNickName] = useState(gcNickName || '');
  const [status, setStatus] = useState('');

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event?.target;
    let _nickName = value;
    const namePattern = /^([A-Za-z0-9:_&$#.\- ])*$/;
    if (!namePattern.test(_nickName)) {
      setStatus('error');
      onError('error');
    } else {
      setStatus('');
      onError('');
    }
    if (namePattern.test(_nickName)) {
      _nickName = _nickName.replace(/’/g, '\'');
    }
    if (_nickName.length <= 30) {
      setNickName(_nickName);
    }
    setNickName(_nickName);
  };

  const renderHelpMessage = () => {
    if (!status) {
      return null;
    }

    return (
      <FormHelpMessage className="sui-text-danger" data-testid="input-card-nickname">
        we only allow letters(a-z),numbers and the following symbols:&_#.-$
      </FormHelpMessage>
    );
  };

  const handleOnBlur = () => {
    onReady(nickName?.trim());
  };
  return (
    <FormController fullWidth>
      <FormLabel optional htmlFor="input-nickname">
        Card Nickname
      </FormLabel>
      <Input
        value={nickName}
        onBlur={handleOnBlur}
        onChange={handleChange}
        status={status}
        inputAttributes={{
          maxLength: 30,
          'aria-labelledby': 'input-nickname',
          'data-testid': 'input-nickname'
        }}
      />
      <FormHelpMessage className="sui-text-subtle" data-testid="input-nickname-count">
        {`${nickName?.length || 0}/30`}
      </FormHelpMessage>
      {renderHelpMessage()}
    </FormController>
  );
};

export { GiftCardNickNameInput };
